import React, { useEffect, useState } from 'react';
import './RequestQuote.css';
import Banner from '../Banner/Banner';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { createOrder } from '../../redux/slices/orderSlice';
import { toast, ToastContainer } from 'react-toastify';
import { Toast } from 'bootstrap/dist/js/bootstrap.bundle.min';

const RequestQuote = () => {
  const { t } = useTranslation("global");
  const dispatch = useDispatch();

  const { isLoading, error, errors } = useSelector((state) => state.order);

  const [formData, setFormData] = useState({
    name: '',
    whatsapp: '',
    email: '',
    country: '',
    port: '',
    interestedProducts: '',
    packaging: '',
    otherNotes: '',
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      name: formData.name,
      whats_number: formData.whatsapp,
      email: formData.email,
      country: formData.country,
      port: formData.port,
      product: formData.interestedProducts,
      packging: formData.packaging,
      notes: formData.otherNotes,
    };

    dispatch(createOrder(payload))
      .unwrap()
      .then((res) => {
        toast.success(res.message || "Request sent successfully.");
        setFormData({
          name: '',
          whatsapp: '',
          email: '',
          country: '',
          port: '',
          interestedProducts: '',
          packaging: '',
          otherNotes: '',
        });
      })
      .catch((err) => {
        const errorMessage = err?.message || err?.response?.data?.message || "Something went wrong.";
        toast.error(errorMessage);
      });

  };



  return (
    <div className="request_quote_section">
      <ToastContainer/>
      <Banner
        currentPage={t("requestquote.title")}
        bg={`url(../../meteor.svg)`}
      />
      <div className='container'>
        <form onSubmit={handleSubmit}>
          <label>{t("requestquote.name")}</label>
          <input name='name' value={formData.name} onChange={handleChange} placeholder={t("requestquote.name")} />

          <label>{t("requestquote.whatsapp")}</label>
          <input name='whatsapp' value={formData.whatsapp} onChange={handleChange} placeholder={t("requestquote.whatsapp")} />
          {errors?.whats_number && <p className="text-danger">{errors.whats_number[0]}</p>}

          <label>{t("requestquote.email")}</label>
          <input name='email' value={formData.email} onChange={handleChange} placeholder={t("requestquote.email")} />

          <label>{t("requestquote.country")}</label>
          <input name='country' value={formData.country} onChange={handleChange} placeholder={t("requestquote.country")} />

          <label>{t("requestquote.port")}</label>
          <input name='port' value={formData.port} onChange={handleChange} placeholder={t("requestquote.port")} />

          <label>{t("requestquote.products")}</label>
          <textarea name='interestedProducts' value={formData.interestedProducts} onChange={handleChange} placeholder={t("requestquote.products")}></textarea>
          {errors?.product && <p className="text-danger">{errors.product[0]}</p>}

          <label>{t("requestquote.packaging")}</label>
          <textarea name='packaging' value={formData.packaging} onChange={handleChange} placeholder={t("requestquote.packaging")}></textarea>
          {errors?.packging && <p className="text-danger">{errors.packging[0]}</p>}

          <label>{t("requestquote.otherNotes")}</label>
          <textarea name='otherNotes' value={formData.otherNotes} onChange={handleChange} placeholder={t("requestquote.otherNotes")}></textarea>
          {errors?.notes && <p className="text-danger">{errors.notes[0]}</p>}

          <div className='text-center mt-3'>
            <button type='submit' disabled={isLoading}>
              {isLoading ? t("requestquote.loading") : t("requestquote.submit")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RequestQuote;
